function deactivateScroll() {
  document.body.style.overflow = "hidden";
}

function activateScroll() {
  document.body.style.overflow = "scroll";
}

export { deactivateScroll, activateScroll };
